module.exports = __webpack_public_path__ + "static/img/bid-circle.04de8218.png";